import { Navigate, Route, Routes } from "react-router-dom";
import AuthGate from "./components/AuthGate";
import ModeratorPage from "./pages/ModeratorPage";
import PlayerPage from "./pages/PlayerPage";

function App() {
  return (
    <AuthGate>
      <Routes>
        <Route path="/game/moderator" element={<ModeratorPage />} />
        <Route path="/game/player1" element={<PlayerPage role="player1" />} />
        <Route path="/game/player2" element={<PlayerPage role="player2" />} />
        <Route path="*" element={<Navigate to="/game/moderator" replace />} />
      </Routes>
    </AuthGate>
  );
}

export default App;
